import { Component, effect, inject, input, signal } from '@angular/core';
import { AppraisalService } from '@services/appraisal-data.service';
import { EvCore, ThousandizePipe, ToShortDateStringPipe } from 'ev-core';
import { DefaultConverterPipe } from 'src/app/shared/pipes/defaultconverter.pipe';
import { IValuationHistoryAppraisalDetails } from 'src/models/estate/appraisal-details.model';
import { AppraisalDenialReasonDetails, AppraisalDialogApprovalStatus, ReportApprovalStatus } from 'src/models/estate/appraisal.model';
import { EvRangebarModule } from 'ev-rangebar';

@Component({
    selector: 'appraisal',
    templateUrl: './appraisal.component.html',
    styleUrls: ['./appraisal.component.scss', '../detail-views.scss'],
    imports: [ThousandizePipe, DefaultConverterPipe, ToShortDateStringPipe, EvCore, EvRangebarModule]
})
export class AppraisalComponent {
  detailAppraisal = input<IValuationHistoryAppraisalDetails>();
  detailSaleInfo = input<AppraisalRejectedInfo>();
  reportId = input<number>();
  appraisalStatus = input<AppraisalDialogApprovalStatus>();
  isLatest = input<boolean>(false);
  appraisalDeniedReasons = input<AppraisalDenialReasonDetails[]>();

  reportApprovalStatus = AppraisalDialogApprovalStatus;
  valueSet = false;
  appraisalService = inject(AppraisalService);

  appraisalHistory = signal<ReportApprovalStatus[]>([]);

  constructor() {
    effect(() => {
      if (this.reportId()) {
        this.appraisalService.getAppraisalReportApprovalHistory(this.reportId()).subscribe(history => {
          this.appraisalHistory.set(history.data);
        })
      }
    });
  }

  getAppraisalDeniedDescription(reasonKey: number) {
    const reasons = this.appraisalDeniedReasons();
    if (reasons) {
      let reason = reasons.find(x => x.appraisalDeniedReason === reasonKey);
      return reason?.appraisalDeniedReasonDescription;
    }
    return null;
  }
}

interface AppraisalRejectedInfo {
  Info: string;
  Chapters: AppraisalChapters;
}

interface AppraisalChapters {
  Header: string;
}
